import React from "react";
import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import EditorFormSection from "../../EditorFormSection";
import { Row, Col } from "reactstrap";
import checkMarkSVG from "../../../assets/images/icons/checkmark.svg";

const LaminateSection = ({ isOpen, togglePanel, laminates }, context) => {
  const { control } = useFormContext();

  const renderLaminateTitle = (key) => {
    switch (key) {
      case "glossy":
        return context.t("Glossy");
      case "matt":
        return context.t("Matt");
      case "none":
        return context.t("None");
      default:
        return key;
    }
  };

  return (
    <EditorFormSection
      help={context.t("FileEditor.laminate.help")}
      panelName="laminate"
      panelTitle={context.t("Select your protective coating (laminate)")}
      open={isOpen}
      toggle={togglePanel}
    >
      <Controller
        name="laminate"
        control={control}
        render={({ field: { value, onChange } }) => (
          <div>
            <Row>
              {laminates?.map((availableLaminate, index) => {
                const isChecked = availableLaminate.key === value;

                return (
                  <Col
                    key={index}
                    xs={4}
                    className={`laminate-field${isChecked ? " selected" : ""}`}
                    onClick={() => onChange(availableLaminate.key)}
                  >
                    <div
                      className={`laminate-field--icon-container${
                        isChecked ? " selected" : ""
                      }`}
                    >
                      <img
                        src={availableLaminate.iconURL}
                        alt={availableLaminate.key}
                        className={`laminate-field--icon laminate-ad-hoc--${availableLaminate.key}`}
                        loading="lazy"
                      />
                      {isChecked && (
                        <img
                          src={checkMarkSVG}
                          alt="selected_option"
                          className="laminate-field--checkmark"
                          loading="lazy"
                        />
                      )}
                    </div>
                    <div className="laminate-field--title text-center">
                      {renderLaminateTitle(availableLaminate.key)}
                    </div>
                  </Col>
                );
              })}
            </Row>
            <p className="text-remark pt-3">
              {context.t(
                "If you want to learn more about protective coating / lamination you should read the help section."
              )}
            </p>
          </div>
        )}
      />
    </EditorFormSection>
  );
};

LaminateSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
  laminates: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      iconURL: PropTypes.string.isRequired,
    })
  ).isRequired,
};

LaminateSection.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default LaminateSection;
